export default "__VITE_ASSET__GgTQDpNe__"